<template>
  <div v-if="!!rating" id="review-section">
    <h2 v-if="!isMobile()" data-sticky-nav-item class="h-0 overflow-hidden">
      Reviews
    </h2>
    <h2
      class="font-medium fs-32 mdsm:fs-24 mb-6 flex lg:flex-row mdsm:flex-col lg:items-center"
    >
      {{ reviewsCount }} Review{{ reviewsCount > 1 ? "s" : "" }}
      <rating size="32" :value="rating.supplier_rating" class="lg:ml-4" />
    </h2>

    <div class="flex flex-wrap mb-6 sm:hidden">
      <div
        class="lg:w-1/2 mdsm:w-full py-2 flex lg:flex-row mdsm:flex-col lg:items-center"
      >
        <div class="lg:w-1/2 mdsm:w-full">Accommodation</div>
        <div class="lg:w-1/2 mdsm:w-full">
          <rating :value="rating.supplier_accomodation_rating" />
        </div>
      </div>
      <div
        class="lg:w-1/2 mdsm:w-full py-2 flex lg:flex-row mdsm:flex-col lg:items-center"
      >
        <div class="lg:w-1/2 mdsm:w-full">Eco-friendliness</div>
        <div class="lg:w-1/2 mdsm:w-full">
          <rating :value="rating.supplier_eco_friendliness_rating" />
        </div>
      </div>
      <div
        class="lg:w-1/2 mdsm:w-full py-2 flex lg:flex-row mdsm:flex-col lg:items-center"
      >
        <div class="lg:w-1/2 mdsm:w-full">Staff</div>
        <div class="lg:w-1/2 mdsm:w-full">
          <rating :value="rating.supplier_staff_rating" />
        </div>
      </div>
      <div
        class="lg:w-1/2 mdsm:w-full py-2 flex lg:flex-row mdsm:flex-col lg:items-center"
      >
        <div class="lg:w-1/2 mdsm:w-full">Underwater experience</div>
        <div class="lg:w-1/2 mdsm:w-full">
          <rating :value="rating.supplier_underwater_experience_rating" />
        </div>
      </div>
      <div
        class="lg:w-1/2 mdsm:w-full py-2 flex lg:flex-row mdsm:flex-col lg:items-center"
      >
        <div class="lg:w-1/2 mdsm:w-full">Food</div>
        <div class="lg:w-1/2 mdsm:w-full">
          <rating :value="rating.supplier_food_rating" />
        </div>
      </div>
      <div
        class="lg:w-1/2 mdsm:w-full py-2 flex lg:flex-row mdsm:flex-col lg:items-center"
      >
        <div class="lg:w-1/2 mdsm:w-full">Dive guides & equipment</div>
        <div class="lg:w-1/2 mdsm:w-full">
          <rating :value="rating.supplier_diving_rating" />
        </div>
      </div>
    </div>

    <div class="py-2 mb-4" v-if="reviews.length > 0">
      <div
        v-for="(item, index) in reviewsDisplay"
        :key="item.id"
        :class="{ 'mt-10': index > 0 }"
      >
        <div class="flex items-center">
          <div class="avatar" v-if="item.guest.avatar_url">
            <img
              width="50"
              height="50"
              :src="getCloudinaryImage(item.guest.avatar_url)"
            />
          </div>
          <div>
            <h4 class="flex items-center">
              {{ item.guest.first_name }} {{ item.guest.last_name.slice(0, 1) }}
              <span class="label-zublu" v-if="item.is_zublu_review">ZuBlu</span>
            </h4>
            <div class="fs-14 text-black-light-5">
              {{ getReviewDate(item.start_date) }}
            </div>
          </div>
        </div>
        <p class="mt-2" v-html="loadReview(item.supplier_review)"></p>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-outlined btn-tertiary sm:w-full mt-4 flex items-center"
      v-if="reviewsDisplay.length < reviews.length"
      @click="onClickShowMore"
    >
      Show more
      <div v-if="isLoading" class="loader ml-2" />
    </button>
  </div>
</template>

<script>
import get from "lodash/get";
import Rating from "../core/Rating";
import { getCloudinaryUrl } from "../../helpers";
const PER_PAGE = 5;

export default {
  name: "ProductDetailReview",
  props: ["resortId"],
  components: { Rating },
  data() {
    return {
      rating: null,
      reviews: [],
      currentPage: 1,
      reviewsCount: 0,
      isLoading: false,
    };
  },
  computed: {
    reviewsDisplay() {
      return this.reviews.slice(0, this.currentPage * PER_PAGE);
    },
  },
  methods: {
    isMobile() {
      return window.matchMedia("only screen and (max-width: 1200px)").matches;
    },
    onClickShowMore() {
      this.currentPage += 1;
    },
    getReviewDate(date) {
      return moment(date).format("MMMM YYYY");
    },
    getCloudinaryImage(url) {
      return getCloudinaryUrl(url, { width: 120 });
    },
    loadReview(review) {
      return review.replace(/\n/g, "<br>");
    },
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((data) => {
      this.rating = get(data, "rating.aggregated_rating");
      this.reviews = this.reviews
        .concat(get(data, "rating.reviews") || [])
        .filter((item) => !!item.supplier_review);
      this.reviewsCount = get(data, "rating.reviews_count");
    });
  },
};
</script>

<style scoped>
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 100vh;
  overflow: hidden;
  margin-right: 16px;
}

.label-zublu {
  font-size: 12px;
  padding: 4px 8px 2px;
  border-radius: 2px;
  background: #45aab5;
  color: white;
  margin-left: 10px;
}

.loader {
  border: 2px solid #dbdbdb;
  border-radius: 50%;
  border-top: 2px solid #000000;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
}
</style>
